import React from 'react';
import Galeria from './Galeria';

const Exposicion = () => (
  <div>
    <h2>EXPOSICIÓN</h2>
    <Galeria />
    <p>
      Exposición colectiva de artistas cubanos en la Ciudad de México,
      presentada del 26 octubre 2019 al 11 de enero de 2020 en la Casa Rafael
      Galván de la Universidad Autónoma Metropolitana.
    </p>
    <p>
      La muestra se inauguró en el marco del Coloquio ¿60 años de qué?
      Itinerarios de la revolución cubana, organizado por la UAM y la IBERO.
      Bajo la curaduría de la Dra. Yissel Arce Padrón, participaron artistas
      relevantes en la escena cubana e internacional de los últimos años:
      Alexandre Arrechea, Ángel Delgado, Celia-Yunior, Eric Silva, Humberto
      Díaz, Luis Gárciga, Marta María Pérez Bravo, Raúl Cordero, René Peña,
      Reynier Leyva Novo, Luis Manuel Otero y Rolando Vázquez. Compuesta por 20
      obras en distintos formatos como fotografía, arte objeto, pintura,
      gráfica, instalación y video, 3 de ellas producidas específicamente para
      el proyecto.
    </p>
  </div>
);
export default Exposicion;
